const featuredCategories = [
  {
    name: 'T-Shirts',
    desc: 'Top bewertet',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20oversized%20t-shirt%20draped%20on%20minimalist%20hanger%2C%20warm%20natural%20lighting%2C%20soft%20cream%20background%2C%20editorial%20fashion%20photography%2C%20clean%20modern%20aesthetic%2C%20subtle%20fabric%20texture%20visible%2C%20elegant%20composition&width=800&height=800&seq=feat-tshirt-01&orientation=squarish',
    bgColor: 'bg-accent-100/50',
  },
  {
    name: 'Jacken',
    desc: 'Bestseller',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20denim%20jacket%20displayed%20on%20wooden%20hanger%20against%20soft%20beige%20wall%2C%20warm%20afternoon%20lighting%2C%20editorial%20fashion%20photography%2C%20minimalist%20composition%2C%20neutral%20earth%20tones%2C%20clean%20aesthetic&width=800&height=800&seq=feat-jacket-02&orientation=squarish',
    bgColor: 'bg-background-200/50',
  },
  {
    name: 'Accessoires',
    desc: 'Beliebteste',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20minimalist%20fashion%20accessories%20artfully%20displayed%20on%20light%20surface%2C%20warm%20studio%20lighting%2C%20editorial%20product%20photography%2C%20cream%20background%2C%20modern%20clean%20aesthetic%2C%20soft%20shadows&width=800&height=800&seq=feat-accessory-03&orientation=squarish',
    bgColor: 'bg-primary-100/50',
  },
];

export default function FeaturedCategories() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            Die beliebtesten Kategorien
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-xl mx-auto">
            Entdecke unsere am besten bewerteten OOPBuy Spreadsheet Kategorien – handverlesen von unserer Community
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.map((item, idx) => (
            <a
              key={idx}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative aspect-square rounded-3xl overflow-hidden cursor-pointer"
            >
              <div className={`absolute inset-0 ${item.bgColor}`}></div>
              <img
                src={item.imageUrl}
                alt={item.name}
                className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-white/70 text-xs font-medium tracking-wider uppercase mb-1">{item.desc}</p>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-white">{item.name}</h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}